module.exports = __webpack_public_path__ + "img/2020china-brand-list.59233a2b.png";